import React from 'react';
import { useParams, useSearchParams, Navigate, Link } from 'react-router-dom';
import '../assets/scss/thank-page.scss';

const ThankPage = () => {
    const { quizId } = useParams();
    const [searchParams] = useSearchParams();
    const isPaymentSuccess = searchParams.get('payment') === 'success';

    // Post-payment now has its own real page (/subscription-success/:quizId).
    // Forward any legacy/in-flight checkout that still lands here with
    // ?payment=success so those buyers get the success screen + conversion pixels.
    if (isPaymentSuccess) {
        return <Navigate to={`/subscription-success/${quizId}`} replace />;
    }

    // Quiz completed without payment — QuizController / Switcher redirect here.
    return (
        <div className="thank-page">
            <div className="thank-page__container">
                <div className="thank-page__check">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#008558" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12" />
                    </svg>
                </div>

                <h1 className="thank-page__heading">Quiz completed</h1>
                <p className="thank-page__subtext">
                    Your responses have been recorded. Thank you for taking the time.
                </p>

                <Link to="/" className="thank-page__button">
                    Back to home
                </Link>
            </div>
        </div>
    );
};

export default ThankPage;
